import * as yup from 'yup'
import moment from 'moment'

export const sortTypes = [
  {value: 'color__asc', label: 'カラー 昇順'},
  {value: 'color__desc', label: 'カラー 降順'},
  {value: 'alert_start__asc', label: '通知日 古い順'},
  {value: 'alert_start__desc', label: '通知日 新しい順'},
  {value: 'alert_type_name__asc', label: 'アラート名 昇順'},
  {value: 'alert_type_name__desc', label: 'アラート名 降順'},
  {value: 'base_date__asc', label: '基準日 古い順'},
  {value: 'base_date__desc', label: '基準日 新しい順'},
  {value: 'staff_code__asc', label: 'スタッフコード 昇順'},
  {value: 'staff_code__desc', label: 'スタッフコード 降順'},
  {value: 'employee_name__asc', label: '氏名 昇順'},
  {value: 'employee_name__desc', label: '氏名 降順'},
]

const validateDate = (startOn?: string, endOn?: string) => {
  return [startOn, endOn].every(
    (date) => date && /^\d{4}[/-]\d{1,2}[/-]\d{1,2}$/.test(date) && moment(date, 'YYYY/MM/DD').isValid()
  )
}

const mainFieldSchema = yup.object().shape({
  searchValue: yup.string().defined(),
  alertStartStartOn: yup
    .string()
    .defined()
    .test('alert-validation', '日付を入力してください', function (alertStartOn) {
      const {alertStartEndOn} = this.parent
      return validateDate(alertStartOn, alertStartEndOn)
    })
    .test('alertStart-validation', '最大3ヶ月間の情報を検索できます', function (value) {
      const {alertStartEndOn} = this.parent
      if (moment(alertStartEndOn).isAfter(moment(value).add(3, 'months').subtract(1, 'days'))) {
        return false
      }
      return true
    })
    .test('alertStart-range-validation', '日付の範囲が正しくありません', function (value) {
      const {alertStartEndOn} = this.parent
      return moment(value, 'YYYY/MM/DD').diff(moment(alertStartEndOn, 'YYYY/MM/DD'), 'days') <= 0
    }),
  alertStartEndOn: yup.string().defined(),
  baseDateStartOn: yup
    .string()
    .defined()
    .test('alert-validation', '日付を入力してください', function (baseDateStartOn) {
      const {baseDateEndOn} = this.parent
      const baseDateStartOnValid =
        !baseDateStartOn ||
        (/^\d{4}[/-]\d{1,2}[/-]\d{1,2}$/.test(baseDateStartOn) && moment(baseDateStartOn, 'YYYY/MM/DD').isValid())
      const baseDateEndOnValid =
        !baseDateEndOn ||
        (/^\d{4}[/-]\d{1,2}[/-]\d{1,2}$/.test(baseDateEndOn) && moment(baseDateEndOn, 'YYYY/MM/DD').isValid())
      return baseDateStartOnValid && baseDateEndOnValid
    })
    .test('baseDate-range-validation', '日付の範囲が正しくありません', function (value) {
      const {baseDateEndOn} = this.parent
      if (!value || !baseDateEndOn) return true
      return moment(value, 'YYYY/MM/DD').diff(moment(baseDateEndOn, 'YYYY/MM/DD'), 'days') <= 0
    }),
  baseDateEndOn: yup.string().defined(),
  alertStatus: yup.string().oneOf(['all', 'in_progress', 'completed']).required(),
  alertTypeIds: yup.array().of(yup.string().required()).required(),
})

const sortTypeSchema = yup.object({
  sortType: yup
    .string()
    .oneOf(sortTypes.map((item) => item.value))
    .required(),
})

const paginatorSchema = yup.object({
  page: yup.string(),
  limit: yup.string(),
})

export const schema = mainFieldSchema.concat(sortTypeSchema).concat(paginatorSchema)

export type Schema = yup.InferType<typeof schema>
